module.exports = __webpack_public_path__ + "img/vertical_6_3_3009.12fca760.png";